export const APPLICATION_NAME = 'Messenger';

export const QUICK_OPTIONS_COUNT_LIMIT = 16;

export const QUICK_SUM_OPTIONS_LENGTH_LIMIT = 150;

export const QUICK_OPTION_LENGTH_LIMIT = 15;

export const GOODBYE_MESSAGE_HEADER = 'Survey Completed';

export const GOODBYE_MESSAGE_CONTENT = 'You have reached the end of the survey.';

export const INVALID_ERROR_MESSAGE = 'No response from server';

export const SURVEY_TESTING_PATH = 'survey-testing';

export const TIMEOUT_DELAY = 150;

export const SMALL_TIMEOUT_DELAY = 100;

export const MILLISECONDS_TO_SECONDS = 1000;

/** Last-resort safety valve for an armed submission that the socket never resolves. Reconnects release
 * the guard on their own, so this only covers a still-open socket that silently never answers. Kept
 * generous on purpose: releasing early re-opens the duplicate-submit window this guard exists to close. */
export const SUBMISSION_IN_FLIGHT_TIMEOUT_MS = 30 * MILLISECONDS_TO_SECONDS;

/** react-use-websocket retry policy for the chat socket. */
export const WEBSOCKET_RECONNECT_ATTEMPTS = 3;
export const WEBSOCKET_RECONNECT_INTERVAL_MS = 3 * MILLISECONDS_TO_SECONDS;

/** Budget for a single connect attempt to fail before the next retry is scheduled. A dropped network
 * fails the handshake on a transport timeout rather than instantly, so the real schedule runs longer
 * than the nominal intervals alone. */
const WEBSOCKET_CONNECT_ATTEMPT_BUDGET_MS = 5 * MILLISECONDS_TO_SECONDS;

/** How long a user-triggered reconnect keeps its queued submit alive before giving up. Must outlast the
 * whole retry schedule (the first attempt plus every retry), otherwise we discard the answer while the
 * library is still trying and the socket may open moments later. */
export const RECONNECT_GIVE_UP_TIMEOUT_MS =
  WEBSOCKET_RECONNECT_ATTEMPTS * WEBSOCKET_RECONNECT_INTERVAL_MS + (WEBSOCKET_RECONNECT_ATTEMPTS + 1) * WEBSOCKET_CONNECT_ATTEMPT_BUDGET_MS;

/** How long an open socket waits for the server to replay the session before it stops holding a
 * queued answer. The server always replays History first and immediately, so this deadline only
 * expires when something is wrong — and a queued answer must not then be sent blind, because the
 * replay we never saw is the only thing that could have told us the survey had moved on. A socket
 * that drops mid-wait cancels the wait instead of expiring it, so this must stay long enough to
 * cover a slow-but-alive connection rather than being tuned to the retry schedule. */
export const POST_RECONNECT_REPLAY_TIMEOUT_MS = 5 * MILLISECONDS_TO_SECONDS;

/** How long a reconnect with nothing queued waits before re-checking a still-closed socket. With no
 * answer riding on it there is nothing to protect by outlasting the retry schedule, so a survey that
 * never existed should not make the respondent wait the full window to be told. */
export const RESUME_GIVE_UP_TIMEOUT_MS = 12 * MILLISECONDS_TO_SECONDS;

export const END_OF_VIDEO_TOLERANCE = 0.75; // seconds - tolerance for considering video "ended"

/** Max width/height (px) for scale legend anchor images */
export const SLIDER_QUESTION_LEGEND_ICON_MAX_PX = 32;
